import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import user from './modules/user';
import contact from './modules/contact';
import device from './modules/device';
import cdn from './modules/cdn';
import outgoing from './modules/outgoing';
import blast_list from './modules/blast_list';
import autoreply from './modules/autoreply';
import order_online from './modules/order_online';
import customer_service from './modules/cs';
import chat_widget from './modules/chat_widget';
import campaign from './modules/campaign';
import link_rotator from './modules/link_rotator';
import packages from './modules/package';
import withdraw from './modules/withdraw';
import incoming from './modules/incoming';
import admin from './modules/admin';
import agency from './modules/agency';
import history from './modules/history';
import autotext from './modules/autotext';
import broadcast_preset from './modules/broadcast_preset';
import category from './modules/category';
import toko from './modules/toko';
import order from './modules/order';
import cs_toko from './modules/cs_toko';
import chat_gpt from './modules/chatgpt';
import daily_leads from './modules/daily_leads';
import group_greeter from './modules/group_greeter';
import node_server from './modules/node_server';
import birthday from './modules/birthday';
import followup from './modules/followup';
import shop_lms from './modules/shop_lms'
import shop_donation from './modules/shop_donation'
import shop from './modules/shop'
import shop_template from './modules/shop_template'
import shop_category from './modules/shop_category'
import shop_balance from './modules/shop_balance'
import public_shop from './modules/public_shop';
import shop_product from './modules/shop_product';
import shop_order from './modules/shop_order';
import lynk from './modules/lynk';
import support_ticket from './modules/support_ticket';
import admin_support_ticket from './modules/admin_support_ticket';
import mayar from './modules/mayar';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    cdn,
    auth,
    user,
    contact,
    device,
    outgoing,
    blast_list,
    autoreply,
    order_online,
    customer_service,
    chat_widget,
    campaign,
    link_rotator,
    packages,
    withdraw,
    incoming,
    admin,
    agency,
    history,
    autotext,
    category,
    toko,
    order,
    cs_toko,
    chat_gpt,
    daily_leads,
    group_greeter,
    node_server,
    birthday,
    followup,
    shop, shop_lms, shop_donation, shop_template, shop_category, shop_balance, public_shop,
    shop_product,
    shop_order,
    lynk,
        mayar,
        support_ticket, admin_support_ticket,
        broadcast_preset
  },
  plugins: [createPersistedState()]
});
